import { IRoles } from '../Models/IRoles';


export const roles: IRoles[] = [
    { roleCd: 'ADMIN', roleDesc: 'Admin' },
    { roleCd: 'USERL1', roleDesc: 'User' }
];
